import angular from 'angular';
import template from './cardgrid.html';
import Form from '~/scripts/services/model/form';

const cardgridConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('cardgrid', {
		title:      'Card grid',
		template,
		group:      'advanced',
		children:   false,
		selectable: true,
		settings:   {
			disabled:  false,
			label:     'Card grid',
			hideLabel: true,
			hidden:    false,
			input:     false,
			tableView: false,
			options:   {
				actions:     {
					delete: true,
					insertCreate: true,
					insertExisting: true,
					refresh: true,
					search: true,
					upload: true,
				},
				descendants: [],
				display:     {
					status: true,
				},
			},
			showLinkedItems: true,
		},
		icon:       'fa fa-server',
		views:      [
			{
				name:     'Display',
				template: 'kform/components/cardgrid/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		/**
		 * @param {any} $scope
		 */
		controller: /* @ngInject */ $scope => {
			$scope.items = [];
			const parent = $scope.$parent;

			// @ts-ignore
			const form = parent.form || undefined;
			$scope.cardGridOptions = { ...$scope.component.options };
			$scope.$watch('component.options', () => {
				$scope.cardGridOptions = {
					...$scope.cardGridOptions,
					...$scope.component.options,
				};
			});

			if (!$scope.builder && form) {
				// $scope.cardGridOptions = {
				// 	descendants: $scope.component.options.descendants,
				// };

				// Recherche du link
				$scope.cardGridOptions.parent = {
					create: form.create,
					kid:    form.kid,
					isa:    form.isa,
					name:   form instanceof Form ? form.getName() : form.name,
					target: $scope.component.options.target,
				};
			}
		},
	});
};

export default angular.module('app')
	.config(cardgridConfig);
